import { formataValorMonetario } from '../../utils/moneyUtils';
import { getEmpresasSelecionadasStorage } from '../../utils/localStorageUtils';

const SET_DEMONSTRATIVO_ACTION = 'SET_DEMONSTRATIVO_ACTION';
const DEFAULT_STATES_ACTION = 'DEFAULT_STATES_ACTION';

export const setDemonstrativoAction = (name, value) => ({
  type: SET_DEMONSTRATIVO_ACTION,
  name,
  value,
});

export const resetDemonstrativoAction = () => ({
  type: DEFAULT_STATES_ACTION,
});

function setDemonstrativoHandler(state, action) {
  const { name, value } = action;
  return {
    ...state,
    [name]: value,
  };
}


function buildDefaultStates() {
  const empresasSelecionadas = getEmpresasSelecionadasStorage() || [];
  return {
    idsCliente: empresasSelecionadas.map(empresa => empresa.idCliente),
    page: 0,
    content: [],
    pageableOptions: {
      count: 0,
      last: false,
    },
    totalPagar: formataValorMonetario(0),
  };
}

function defaultStatesHandler() {
  return buildDefaultStates();
}

const initialStates = () => buildDefaultStates();

const demonstrativoReducer = (state = initialStates(), action) => {
  switch (action.type) {
    case SET_DEMONSTRATIVO_ACTION:
      return setDemonstrativoHandler(state, action);
    case DEFAULT_STATES_ACTION:
      return defaultStatesHandler();
    default:
      return state;
  }
};

export default demonstrativoReducer;
